import {statusBorderColor, statusColor, statusFontColor} from '../../../../../enums/statusColorEnum';
import { status } from '../../../../../enums/statusEnum';
import NotInformation from '../../../../../components/NotInformation';
import {
    CompletePersonChip, EmailSubsectionChip,
    IconPersonDefaultV2,
    PhoneSubsectionChip
} from "../../../../../components/buttons/IconButtons";
import CustomChip from "../../../../../components/CustomChip";
import {EMPTY_VALUES, getFullName} from "../../../../../Apis/functions";
import RowCardText from "../../../../../components/RowCardText";
import CustomTooltip from "../../../../../components/CustomTooltip";
import CustomCardGridGeneral from "../../../../../components/CustomCardGridGeneral";
import {useTranslation} from "react-i18next";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const EmployeeOrderDetail = ({ getOrderDetails, renderEmployeeButton }) => {
    const { t } = useTranslation();
    return (
       <>
           <div className={'d-flex align-items-center m-3'}>
               <CustomGenericTittleIconDataChip
                   title={t('assigned_employee')}
                   Icon={CompletePersonChip}
                   border={false}
                   classNameTittleContainer={'mb-0'}
                   titleBoxClass={'d-flex'}
               />
           </div>
           <div className={'border-bottom-shades-300 mb-3'} />
           { getOrderDetails?.supplierEmployeeId ? (
               <CustomCardGridGeneral
                   head={
                       <>
                           <div
                               className='h-144px img-container img-background-primary-20 d-flex
                                                    flex-column justify-content-center align-items-center gap-2 flex-fill
                                                    align-self-stretch position-relative overflow-hidden'
                           >
                               {getOrderDetails?.supplierEmployeeSelfie && (
                                   <img
                                       src={`data:image/png;base64,${getOrderDetails?.supplierEmployeeSelfie}`}
                                       alt='profile'
                                       className='w-100 h-100 img-filter-background'
                                   />
                               )}
                               <div className={'position-absolute gap-2 w-100 t-10px'}>
                                   <div className={'pl-2 pr-20px'}>
                                       <div className={'d-flex justify-content-end align-items-center'}>
                                           <CustomChip
                                               legend={t(status[getOrderDetails?.supplierEmployeeStatusId])}
                                               borderColor={statusBorderColor[getOrderDetails?.supplierEmployeeStatusId]}
                                               fontColor={statusFontColor[getOrderDetails?.supplierEmployeeStatusId]}
                                               background={statusColor[getOrderDetails?.supplierEmployeeStatusId]}
                                               variant={'large'}
                                           />
                                       </div>
                                   </div>
                               </div>
                           </div>
                           <div className={'h-60px position-relative'}>
                               {getOrderDetails?.supplierEmployeeSelfie ? (
                                   <div className={'position-absolute t-50-l-50 t-0-center'}>
                                       <img
                                           className={'w-120px h-120px image-card-grid'}
                                           src={`data:image/png;base64,${getOrderDetails?.supplierEmployeeSelfie}`}
                                           alt='add'
                                       />
                                   </div>
                               ) : (
                                   <div className={'position-absolute t-50-l-50 t-0-center'}>
                                       <IconPersonDefaultV2 />
                                   </div>
                               )}
                           </div>
                       </>
                   }
               >
                   <div className='h-54px position-relative w-100'>
                       <div className={'position-absolute t-50-l-50 w-100'}>
                           <CustomTooltip
                               text={getFullName(getOrderDetails?.supplierEmployeeName,
                                   getOrderDetails?.supplierEmployeeLastName,
                                   getOrderDetails?.supplierEmployeeSecondLastName) || EMPTY_VALUES.DEFAULT}
                               classes={'ibl-h3 font-color-general-950 ibl-font-w-600 text-center text-ellipsis-2-rows'}
                               showIfTruncated={true}
                               placement={'top'}
                           />
                       </div>
                   </div>

                   <div className={'border-bottom-shades-300-2px'} />

                   <div className='position-relative w-100 my-3'>
                       <div className={'position-absolute t-50-l-50 w-100'}>
                           <RowCardText
                               icon={<EmailSubsectionChip className='w-20px' />}
                               title={t('email')}
                               value={getOrderDetails?.supplierEmployeeEmail || EMPTY_VALUES.DEFAULT}
                           />
                       </div>
                   </div>

                   <div className='position-relative w-100 mb-3'>
                       <div className={'position-absolute t-50-l-50 w-100'}>
                           <RowCardText
                               icon={<PhoneSubsectionChip className='w-20px' />}
                               title={t('phone_number')}
                               value={getOrderDetails?.supplierEmployeePhoneNumber || EMPTY_VALUES.DEFAULT}
                           />
                       </div>
                   </div>
                   { renderEmployeeButton(getOrderDetails?.supplierEmployeeUserId)}
               </CustomCardGridGeneral>
           ) : (
               <div className={'col-12 p-0'}>
                   <NotInformation text={t('no_information')} card={true} />
               </div>
           )}
       </>
    );
};

export default EmployeeOrderDetail;
